import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
declare var jQuery: any;

@Component({
  selector: 'app-shop-single',
  templateUrl: './shop-single.component.html',
  styleUrls: ['./shop-single.component.scss']
})
export class ShopSingleComponent implements OnInit {

  is_authenticate_user: boolean = false;
  user: any;
  producttList: any = "";
  producttSingle: any = {};
  producttRequest: any = {};
  cartRequest: any = {};

  constructor(
    public authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    if (this.authService.isLoggedIn == true) {
      this.is_authenticate_user = true;
      //this.loginactivefunction();
    } else {
      this.router.navigate(['/singin']);
    }

    this.authService.getProduct().then((data) => { this.producttList = data });

    this.activatedRoute.params.subscribe((data) => {
      if (data.slug) {

        this.getProduct(data.slug);
        //this.newsRequest = data.slug;
      }
    });

  }

  getProduct(productslug) {
    this.producttRequest.product_category_id = productslug;
    let request = Object.assign({}, this.producttRequest)
    this.authService.getSingleproduct(request).then((data) => {
      this.producttSingle = data.data || {};

      console.log(this.producttSingle);
      setTimeout(function () {


        jQuery("#minus_btn").click(function () {
          var qtyval = jQuery("#quantity").val();
          if (qtyval > 1) {
            qtyval = parseInt(qtyval) - 1;
            jQuery("#quantity").val(qtyval);
          }
        });
        jQuery("#plus_btn").click(function () {
          var qtyval = jQuery("#quantity").val();
          qtyval = parseInt(qtyval) + 1;
          jQuery("#quantity").val(qtyval);
        });

        jQuery(".increment-quantity").click((e) => {
          var dataid = e.currentTarget.id;
          var qtyval = jQuery("#quantity" + dataid).val();
          var prival = jQuery("#price" + dataid).val();

          qtyval = parseInt(qtyval) + 1;
          jQuery("#quantity" + dataid).val(qtyval);
          this.generalCount = true;
          this.generaladAdult = jQuery('#pNos' + dataid).html(qtyval + ' Nos.');
          this.generaladAdultvalue = jQuery('#pPrice' + dataid).html('£' + qtyval * prival + '.00');
        });
        jQuery(".decrement-quantity").click(function () {
          var dataid = jQuery(this).attr('id');
          var qtyval = jQuery("#quantity" + dataid).val();
          var prival = jQuery("#price" + dataid).val();
          if (qtyval > 1) {
            qtyval = parseInt(qtyval) - 1;
            jQuery("#quantity" + dataid).val(qtyval);
            this.generaladAdultCount = qtyval;
            this.generaladAdult = jQuery('#pNos' + dataid).html(qtyval + ' Nos.');
            this.generaladAdultvalue = jQuery('#pPrice' + dataid).html('£' + qtyval * prival + '.00');
          }
        });
      }, 1000);

    });
  }

  add_to_cart() {
    var finalvalue = "";
    var mastervalue = "";
    var sizevalue = "";
    var finalid = "";
    
    jQuery('.increment-quantity').each(function () {
      var dataid = jQuery(this).attr('id');
      var qtyval = jQuery("#quantity" + dataid).val();
      var sizeval = jQuery("#product_size_id" + dataid).val();
      var masterval = jQuery("#product_master_id" + dataid).val();
      if (qtyval > 0) {
        finalvalue = finalvalue + qtyval + ',';
        sizevalue = sizevalue + sizeval + ',';
        mastervalue = mastervalue + masterval + ',';
        finalid = finalid + dataid + ',';
        //console.log(finalvalue);
      }

    });
    
    finalvalue = finalvalue.replace(/,(?=\s*$)/, '');
    sizevalue = sizevalue.replace(/,(?=\s*$)/, '');
    mastervalue = mastervalue.replace(/,(?=\s*$)/, '');
    finalid = finalid.replace(/,(?=\s*$)/, '');
    this.cartRequest = {

      type: "Merchandise",
      product_master_id: mastervalue,
      product_size_id: sizevalue,
      quantity: finalvalue
    };
    let request: any = {
    };
    request = Object.assign({}, this.cartRequest);
    this.authService.getUsercart(request).then(
      (res) => {
        jQuery("#addtocart").removeClass("show");
        jQuery("#addtocart").addClass("hidden");

        jQuery("#gototcart").removeClass("hidden");
        jQuery("#gototcart").addClass("show");

        //console.log(res.data);
        /*this.addedtocartPopup();*/

        
      }).catch((err) => {
        //console.log(err);
      });

  }

}
